import UserProfileIcon from './UserProfileIcon';

export default UserProfileIcon;